






















import { LauncherLink } from '@/app/httpSettings/LauncherLinks'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class TedsLauncherLinkCard extends Vue {
  @Prop()
  public link!: LauncherLink
}
